'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import withFileManagerDrawer from 'DesignEditorsUI/components/shared/hoc/withFileManagerDrawer';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.linkedFiles.otherAssets.${key}`;

class AddAssetLink extends Component {
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-selenium": "add-asset-link",
        onClick: this.props.onFileManagerOpen,
        use: "link",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('addFile')
          })
        })
      }), this.props.FileManager]
    });
  }

}

AddAssetLink.propTypes = {
  onFileManagerOpen: PropTypes.func.isRequired,
  FileManager: PropTypes.node
};
export default withFileManagerDrawer(AddAssetLink);